import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { PipesModule } from '@jht/brand-pipes';
import { TranslateModule } from '@jht/brand-translate';

import { ContentService } from '../../../shared/content';
import { BASE_SUFFIXES } from '../translation-suffixes';
import { PartialsHelpersService } from '../partials-helpers.service';
import { CardComponent } from '../../../shared/components/card/card.component';

interface CardItem {
    'button-text': string;
    'button-url': string;
    description: string;
    image: string;
    'image-alt-text': string;
    'link-url': string;
    'link-text': string;
    title: string;
    'video-url'?: string;
}

interface Card {
    'product-pdb-id': number;
    'card-type': 'icon' | 'full-image';
    'card-item': CardItem[];
}

@Component({
    selector: 'vision2-section-5',
    imports: [CommonModule, PipesModule, TranslateModule, CardComponent],
    templateUrl: './section-5.component.html',
    styleUrl: './section-5.component.scss',
})
export class Section5Component implements OnChanges {
    @Input() productData: any;
    groupedContent: Record<string, any[]> = {};
    hasValidTranslations = false;

    componentData$: Observable<Card[]>;
    pdbId: number;

    constructor(
        private contentService: ContentService,
        private helpers: PartialsHelpersService,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.getTranslations();

        this.pdbId = this.productData.id;
        this.getComponentData(this.pdbId);
    }

    getTranslations(): void {
        this.groupedContent = {
            'SECTION-5': this.helpers.translateContentGroup(
                this.productData,
                'SECTION-5',
                BASE_SUFFIXES,
                [],
            ),
        };

        this.hasValidTranslations = this.helpers.hasValidTranslation(
            this.groupedContent,
        );
    }

    getComponentData(pdbId: number) {
        this.componentData$ = this.contentService
            .getComponent('product-page-card-grid')
            .pipe(
                filter((data) => !!data),
                map((data: any[]) => {
                    return data.filter(
                        (item) => +item['product-pdb-id'] === pdbId,
                    )[0];
                }),
            );
    }
}
